import React, {Component} from "react"

import { 
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from "@material-ui/core"

/**
 * onCreateClick(name)
 * onCancelClick
 */

class CreateFolderDialog extends Component {

    constructor(props) {
        super(props)

        this.state = {
            name: "",
        }
    }

    readyToCreate = () => Boolean(this.state.name)

    render() {
        return <Dialog open fullWidth>
            <DialogTitle>Создать папку</DialogTitle>
            <DialogContent style = {{display: "flex", flexDirection: "column"}}>
                <TextField
                    value = {this.state.name}
                    label = "Название папки"
                    margin = "normal"
                    onChange = {e => {
                        e.preventDefault()
                        this.setState({name: e.target.value})
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    disabled = {!this.readyToCreate()}
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onCreateClick === "function") {
                            this.props.onCreateClick(this.state.name)
                        }
                    }}
                >Создать</Button>
                <Button
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onCancelClick === "function") {
                            this.props.onCancelClick()
                        }
                    }}
                >Отмена</Button>
            </DialogActions>
        </Dialog>
    }

}

export default CreateFolderDialog